import React, { useContext, useState } from "react";
import Sidebar from "../../layout/Sidebar/SideBar";
import Navbar from "../../layout/Navbar/Navbar";
import BarcodeGenerator from "../../components/BarcodeGenerator";
import ButtonCustom from "../../components/buttons/ButtonCustom";
import "../../styles/Style.css";
import { TextField } from "@mui/material";
import language from "../../nls/language.json";
import Context from "../../context/Context";

export default function BarcodeLogin() {
  const [user, setUser] = useState<string>();
  const [password, setPassword] = useState<string>();
  const [showBarCode, setShowBarcode] = useState<boolean>(false);

  const {
    selectedCountry
  } = useContext(Context);

  return (
    <>
      <Navbar />
      <Sidebar />
      <div className="app_body">
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 10,
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <TextField
            label="Login"
            value={user}
            onChange={(e) => setUser(e.target.value)}
          />

          <TextField
            label="Senha"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <ButtonCustom
            typeButton="contained"
            onClick={() => {
              setShowBarcode(true);
            }}
          >
            {" "}
            {(language as Record<string, any>)[selectedCountry.name].Permissoes.devConfig.btnGerar}
          </ButtonCustom>
          {showBarCode ? <BarcodeGenerator login={user} password={password} /> : <div></div>}
        </div>
      </div>
    </>
  );
}
